import {environment} from '../environments/environment';

/**
 * AppSettingApi
 * APIのエンドポイント用
 */
export class AppSettingApi {

	// APIの接続先サーバ
	public static API_HOST_URL = environment.API_HOST_URL;


	////////////////////////////////
	// ログイン
	// ゲスト登録
	public static GUEST_USER_REGISTER = AppSettingApi.API_HOST_URL + '/api/GuestUser/register.json';
	// ゲストユーザー情報取得
	public static GUEST_USER_INFO_GET = AppSettingApi.API_HOST_URL + '/api/GuestUser/getGuestUser.json';
	// ゲストユーザーのコード再送信要求
	public static GUEST_USER_CODE_RESEND = AppSettingApi.API_HOST_URL + '/api/GuestUser/update.json';
	// ゲストユーザーの情報チェック
	public static GUEST_USER_CHECK = AppSettingApi.API_HOST_URL + '/api/GuestUser/check.json';
	// メアド/パスワードでのログイン
	public static AUTH_LOGIN = AppSettingApi.API_HOST_URL + '/api/Account/login.json';
	// Lineログイン：設定取得
	public static AUTH_LOGIN_LINE_AUTH_CONFIG = AppSettingApi.API_HOST_URL + '/api/external/Line/getConfigForClient.json';
	// Lineログイン：認可記録
	public static AUTH_LOGIN_LINE_RECORD_AUTH = AppSettingApi.API_HOST_URL + '/api/external/Line/recordAuth.json';
	// Lineログイン：認可コールバック記録
	public static AUTH_LOGIN_LINE_RECORD_AUTH_CALLBACK = AppSettingApi.API_HOST_URL + '/api/external/Line/recordAuthCallBack.json';
	// Line：アクセストークンとIDトークンの取得
	public static AUTH_LOGIN_LINE = AppSettingApi.API_HOST_URL + '/api/external/Line/authenticatedUser.json';
	// パスワード忘れメール送信
	public static AUTH_LOGIN_FORGET_PASSWORD = AppSettingApi.API_HOST_URL + '/api/Account/sendResetPassword.json';
	// ログイン状態でのパスワード忘れメール送信
	public static AUTH_LOGIN_FORGET_PASSWORD_INLOGIN = AppSettingApi.API_HOST_URL + '/api/Account/sendResetPasswordInLogin.json';
	// パスワード再設定
	public static AUTH_LOGIN_RESET_PASSWORD = AppSettingApi.API_HOST_URL + '/api/Account/resetPassword.json';
	// パスワード変更
	public static AUTH_CHANGE_PASSWORD = AppSettingApi.API_HOST_URL + '/api/Account/changePassword.json';
	// パスワード変更
	public static AUTH_CREATE_PASSWORD = AppSettingApi.API_HOST_URL + '/api/Account/createPassword.json';
	// パスワードの存在チェック
	public static AUTH_EXIST_PASSWORD = AppSettingApi.API_HOST_URL + '/api/Account/isPassword.json';

	////////////////////////////////
	// ユーザー情報
	// 自サーバーに登録されたユーザー情報の取得
	public static USER_INFO_GET = AppSettingApi.API_HOST_URL + '/api/User/get.json';
	// ユーザー情報の保存
	public static USER_INFO_SAVE = AppSettingApi.API_HOST_URL + '/api/User/register.json';
	// 診察券番号（カルテ番号）とクリニック情報の保存
	public static USER_INFO_MED_SAVE = AppSettingApi.API_HOST_URL + '/api/MedicalRecord/register.json';
	// ユーザー情報の更新
	public static USER_INGO_UPDATE = AppSettingApi.API_HOST_URL + '/api/User/update.json';
	// オンライン診療に必要な情報の更新
	public static USER_INFO_ONLINE_MEDICAL_DATA_UPDATE = AppSettingApi.API_HOST_URL + '/api/User/updateOnlineMedicalData.json';
	// LINE連携解除
	public static USER_LINE_UNLINK = AppSettingApi.API_HOST_URL + '/api/external/Line/deleteUser.json';
	// Lineとの連携状態を取得する
	public static USER_LINE_STATUS = AppSettingApi.API_HOST_URL + '/api/external/Line/profile.json';

	////////////////////////////////
	// 保険証関連
	// アップロード
	public static HEALTH_INSURE_UPLOAD = AppSettingApi.API_HOST_URL + '/api/HealthInsure/upload.json';
	// 変更
	public static HEALTH_INSURE_UPDATE = AppSettingApi.API_HOST_URL + '/api/HealthInsure/update.json';
	// 削除
	public static HEALTH_INSURE_DELETE = AppSettingApi.API_HOST_URL + '/api/HealthInsure/delete.json';
	// 取得
	public static HEALTH_INSURE_LIST = AppSettingApi.API_HOST_URL + '/api/HealthInsure/list.json';

	////////////////////////////////
	// 検査結果
	// 検査結果一覧の取得
	public static USER_DIAGNOSE_LIST_GET = AppSettingApi.API_HOST_URL + '/api/InspectionResult/list.json';
	// 検査結果詳細の取得
	public static USER_DIAGNOSE_DETAIL_GET = AppSettingApi.API_HOST_URL + '/api/InspectionResult/get.json';

	// 請求情報
	// 請求一覧の取得
	public static PAYMENT_LIST = AppSettingApi.API_HOST_URL + '/api/Payment/listByUserId.json';
	// 請求詳細の取得
	public static PAYMENT_DETAIL = AppSettingApi.API_HOST_URL + '/api/Payment/detail.json';


	////////////////////////////////
	// PCR申込
	// 検体情報取得
	public static PCR_SPECIMEN_GET = AppSettingApi.API_HOST_URL + '/api/Pcr/getSpecimen.json';
	// 検査情報取得
	public static PCR_EXAMINE_GET = AppSettingApi.API_HOST_URL + '/api/Pcr/getExamine.json';
	// 検体番号チェック
	public static PCR_SPECIMEN_IS_USABLE = AppSettingApi.API_HOST_URL + '/api/Pcr/isUsableSpecimenNumber.json';
	// PCR問診票
	public static PCR_INTERVIEW_MST = AppSettingApi.API_HOST_URL + '/api/Pcr/listQuestion.json';
	// PCR問診マスタ
	public static PCR_INTERVIEW_SAVE = AppSettingApi.API_HOST_URL + '/api/Pcr/saveInterview.json';

	////////////////////////////////
	// 郵便番号関連
	// 郵便番号から住所を取得
	public static ADDRESS_GET = AppSettingApi.API_HOST_URL + '/api/external/PostCode/getAddress.json';


	////////////////////////////////
	// ファイル関連
	public static FILE_DOWNLOAD = AppSettingApi.API_HOST_URL + '/api/File/download.json';

	////////////////////////////////
	// 予約管理
	// 予約
	public static RESERVATION_LIST_BY_DOCTOR_ID_FROM_TO = AppSettingApi.API_HOST_URL + '/api/Reservation/getListByDoctorIdFromTo.json';
	public static RESERVATION_LIST = AppSettingApi.API_HOST_URL + '/api/Reservation/getList.json';

	// ログインユーザー予約作成
	public static RESERVATION_CREATE_BY_USER = AppSettingApi.API_HOST_URL + '/api/Reservation/createByUser.json';
	public static RESERVATION_UPDATE = AppSettingApi.API_HOST_URL + '/api/Reservation/update.json';
	public static RESERVATION_CANCEL = AppSettingApi.API_HOST_URL + '/api/Reservation/cancel.json';

	// 匿名予約作成
	public static RESERVATION_CREATE = AppSettingApi.API_HOST_URL + '/api/Reservation/createByAnonymous.json';
	public static RESERVATION_GET_TMP_RESERVE = AppSettingApi.API_HOST_URL + '/api/Reservation/getTmpReserve.json';
	public static RESERVATION_DELETE_TMP_RESERVE = AppSettingApi.API_HOST_URL + '/api/Reservation/deleteTmpReserve.json';

	// 予約初期画面データ取得
	public static RESERVATION_GET_START_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/Reservation/getStartViewData.json';
	// 予約日時選択画面のデータ取得
	public static RESERVATION_GET_SELECT_DATE_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/Reservation/getSelectDateViewData.json';
	// 予約更新画面データ取得
	public static RESERVATION_GET_UPDATE_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/Reservation/getUpdateViewData.json';
	// 予約確認で必要な規約の取得
	public static RESERVATION_GET_AGREEMENT = AppSettingApi.API_HOST_URL + '/api/Reservation/getAgreement.json';
	// 予約詳細画面のデータ取得
	public static RESERVATION_GET_DETAIL_VIEW_DATA = AppSettingApi.API_HOST_URL + '/api/Reservation/getDetailViewData.json';
	// 予約完了メッセージの送信
	public static RESERVATION_SEND_COMPLETE_MESSAGE = AppSettingApi.API_HOST_URL + '/api/Reservation/sendCompleteMessage.json';
	// 予約変更メッセージの送信
	public static RESERVATION_SEND_UPDATE_MESSAGE = AppSettingApi.API_HOST_URL + '/api/Reservation/sendUpdateMessage.json';
	// 予約キャンセルメッセージの送信
	public static RESERVATION_SEND_CANCEL_MESSAGE = AppSettingApi.API_HOST_URL + '/api/Reservation/sendCancelMessage.json';

	// 保険外負担に関する同意書への同意
	public static RESERVATION_AGREEMENT_NONE_INSURE = AppSettingApi.API_HOST_URL + '/api/Reservation/agreementNoneInsure.json';
	public static RESERVATION_GET_ONLINE_AGREEMENT = AppSettingApi.API_HOST_URL + '/api/Reservation/getOnlineAgreement.json';

	// 無呼吸アンケートの送信
	public static SAS_SAVE = AppSettingApi.API_HOST_URL + '/api/SasSurvey/save.json';
	public static SAS_QUESTION_LIST = AppSettingApi.API_HOST_URL + '/api/SasSurvey/question.json';
	public static SAS_SAVE_REQUEST = AppSettingApi.API_HOST_URL + '/api/SasRequest/save.json';

	// お支払い手続き
	public static EXAM_AFTER_PROCESS_GET_INITIAL_DATA = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/getFirstViewData.json';
	public static EXAM_AFTER_PROCESS_SAVE = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/saveExamAfterProcess.json';
	public static EXAM_AFTER_PROCESS_REGISTER_MEDICINE_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/saveMedicineDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_REGISTER_PRESCRIPTION_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/savePrescriptionDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_REGISTER_STORE_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/savePrescriptionFaxStore.json';
	public static EXAM_AFTER_PROCESS_CREATE_PAYMENT_URL = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/createPaymentUrl.json';

	public static EXAM_AFTER_PROCESS_UPDATE_HOME_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/updatePrimaryAddress.json';
	public static EXAM_AFTER_PROCESS_UPDATE_MEDICINE_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/updateMedicineDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_UPDATE_PRESCRIPTION_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/updatePrescriptionDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_UPDATE_STORE_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/updatePrescriptionFaxStore.json';

	public static EXAM_AFTER_PROCESS_DELETE_MEDICINE_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/deleteMedicineDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_DELETE_PRESCRIPTION_DELIVERY_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/deletePrescriptionDeliveryAddress.json';
	public static EXAM_AFTER_PROCESS_DELETE_STORE_ADDRESS = AppSettingApi.API_HOST_URL + '/api/ExamAfterProcess/deletePrescriptionFaxStore.json';



	/////////////////////////////////////
	// ユーザー操作ログ
	public static LOG_USER = AppSettingApi.API_HOST_URL + '/api/Log/save.json';
}
